export const EMPTY_Y_ZERO_VALUES = ['0', '0', '0', '0', '0'] as const;

export const getEmptyXAxisValues = (daysCount = 7, date = new Date()): string[] => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);

  return Array.from({ length: daysCount }, (_, index) => {
    const day = String(index + 1).padStart(2, '0');

    return `${day}.${month}.${year}`;
  });
};
